import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

function FooterInfo() {
    return (
        <div className="lg:col-span-7">
            <p className="font-display text-2xl text-[#0B132B] font-medium tracking-tight">
                Simon Marie
            </p>
            <p
                className="mt-1 text-sm text-slate-700"
                data-testid="footer-title"
            >
                Consultant en protection des données personnelles et
                conformité réglementaire
            </p>
            <p className="mt-1 text-sm text-slate-500">
                Profession libérale ·{" "}
                <span data-testid="footer-domain">donnees-et-droit.fr</span>
            </p>
            <p className="mt-6 text-base text-slate-600 leading-relaxed max-w-lg">
                Conseil en protection des données personnelles, pratiques
                numériques et conformité réglementaire pour dirigeants,
                indépendants et structures patrimoniales.
            </p>
        </div>
    );
}

function FooterPresence() {
    return (
        <div className="lg:col-span-3 lg:col-start-10">
            <p className="text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                Présence
            </p>
            <a
                href="https://www.linkedin.com/company/donnees-droit/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-[#0B132B] hover:text-[#1B4332] transition-colors"
                data-testid="footer-linkedin"
            >
                LinkedIn
                <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
        </div>
    );
}

function FooterBottom() {
    return (
        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
            <p className="text-xs text-slate-500">
                © {new Date().getFullYear()} Simon Marie — donnees-et-droit.fr
            </p>
            <Link
                to="/mentions-legales-confidentialite"
                className="text-xs text-slate-600 hover:text-[#0B132B] underline underline-offset-4 decoration-slate-300 hover:decoration-[#0B132B] transition-colors"
                data-testid="footer-legal-link"
            >
                Mentions légales et confidentialité
            </Link>
        </div>
    );
}

export function Footer() {
    return (
        <footer className="bg-[#F9F9F8]" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 pt-12 md:pt-24 pb-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 pb-12 border-b border-slate-200">
                    <FooterInfo />
                    <FooterPresence />
                </div>
                <FooterBottom />
            </div>
        </footer>
    );
}
